var React = require('react');

function Previous (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"none","strokeLinecap":"round","key":0},[React.createElement("path",{"d":"M0 14.151L24.79 0l24.79 14.151v26.577l-24.79 13.92L0 40.728z","key":0}),React.createElement("path",{"fill":"#fff","d":"M24.79 2.303L2 15.313v24.244l22.79 12.797 22.79-12.797V15.312L24.79 2.302m0-2.302l24.79 14.151v26.577l-24.79 13.92L0 40.728V14.15L24.79 0z","key":1})]),React.createElement("path",{"fill":"#fff","d":"M18.366 26.693l7.334-7.337a.9.9 0 011.275 0l.54.54a.9.9 0 010 1.275l-6.158 6.158 6.168 6.164a.9.9 0 010 1.275l-.54.54a.9.9 0 01-1.275 0l-7.34-7.34a.91.91 0 010-1.279z","key":1})]);
}

Previous.defaultProps = {"width":"49.58","height":"54.648","viewBox":"0 0 49.58 54.648"};

module.exports = Previous;

Previous.default = Previous;
